<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<!-- Start of main navbar section -->

<div *ngIf="(vm$ | async) as vm" class="top-panel fixed-top">

    <!-- Start of empty navbar section until data is loaded -->

    <ng-template [ngIf]="!loaded">
        <nav class="navbar navbar-expand-lg">
            <div class="navbar-collapse collapse order-4 order-md-0 collapsenav">
                <ul class="navbar-nav">
                    <li class="top-nav nav-item">&nbsp;
                    </li>
                </ul>
            </div>
        </nav>
    </ng-template>

    <!-- End of empty  section until data is loaded -->

    <!-- Start of empty navbar with logo -->

    <ng-container *ngIf="loaded">
        <ng-container *ngIf="!this.isUserLoggedIn">
            <nav class="navbar ml-0 pl-0">
                <div class="navbar-collapse">
                    <ul class="navbar-nav">
                        <li class="pl-0">
                            <scrm-logo-ui></scrm-logo-ui>
                        </li>
                    </ul>
                </div>
            </nav>
        </ng-container>

        <!-- End of empty navbar section with logo -->

        <!-- Start of mobile navigation section -->

        <ng-container *ngIf="this.isUserLoggedIn && mobileNavbar">
            <ul class="navbar mobile-nav-block mobilenavbar">
                <div class="d-flex">
                    <button (click)="toggleSidebar()" class="navbar-toggler" type="button">
                        <scrm-image class="responsive-menu-toggler" image="hamburger"></scrm-image>
                    </button>
                    <nav class="navbar-expand" [ngClass]="(isSmallScreen() && isSearchBoxVisible()) ? 'd-none' : 'd-block'">
                        <ul class="navbar-nav h-100">
                            <li *ngIf="navbar.current && !navbar.current.isGroupedMenu" class="top-nav nav-item dropdown mobile-navbar-active-module h-100 non-grouped">
                                <scrm-menu-item [item]="navbar.current"></scrm-menu-item>
                            </li>
                            <li *ngIf="navbar.current?.submenu  && navbar.current.isGroupedMenu" class="top-nav nav-item dropdown mobile-navbar-active-module main-grouped">
                                <scrm-grouped-menu-item
                                    [item]="navbar.current"
                                    [subNavCollapse]="subNavCollapse">
                                </scrm-grouped-menu-item>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div class="d-flex align-items-center">
                    <ng-container *ngTemplateOutlet="actionIcons"></ng-container>
                    <div class="global-links action-dropdown" ngbDropdown>
                        <li class="global-link-item">
                            <a #mobileGlobalLinkTitle class="nav-link primary-global-link dropdown-toggle"
                               ngbDropdownToggle>
                                <scrm-image class="global-action-icon sicon-2x" image="user"></scrm-image>
                            </a>
                            <div [style.min-width.px]="mobileGlobalLinkTitle.offsetWidth"
                                 aria-labelledby="navbarDropdownMenuLink"
                                 class="dropdown-menu global-links-dropdown border shadow-sm-2" ngbDropdownMenu>
                                <span
                                    class="global-user-name">{{ navbar.currentUser.firstName }} {{ navbar.currentUser.lastName }}</span>
                                <ng-template [ngIf]="navbar.globalActions">
                                    <ng-container
                                        *ngFor="let globalAction of navbar.globalActions; let first = first; let last = last;">
                                        <a class="dropdown-item global-links-sublink"
                                           href="{{ globalAction.link.url }}"
                                           ngbDropdownItem
                                           target="{{ globalAction.link.target }}">{{ globalAction.link.label }}
                                        </a>
                                        <hr *ngIf="last === true || first === true"/>
                                    </ng-container>
                                </ng-template>
                                <scrm-logout-ui></scrm-logout-ui>
                            </div>
                        </li>
                    </div>
                </div>

            </ul>

        </ng-container>

        <!-- End of mobile navigation section-->

        <!-- Start of navbar section with data once authenticated -->

        <ng-container *ngIf="this.isUserLoggedIn && !mobileNavbar">
            <nav class="navbar navbar-expand-md navbar-1">
                <div [ngbCollapse]="mainNavCollapse" class="navbar-collapse collapse collapsenav">
                        <scrm-home-menu-item
                            [active]="vm.appState.module && vm.appState.module === 'home'"
                            [route]="getHomePage()"
                        ></scrm-home-menu-item>

                        <!-- Navbar with grouped tabs -->

                        <ng-container *ngIf="vm.userPreferences['navigation_paradigm'] == 'gm'">

                            <ul class="navbar-nav grouped">

                                <ng-container *ngIf="navbar.current && navbar.current.isGroupedMenu">
                                    <li class="top-nav nav-item dropdown main-grouped">
                                        <scrm-grouped-menu-item
                                                [item]="navbar.current"
                                                [subNavCollapse]="subNavCollapse"
                                                [index]="1"
                                        >
                                        </scrm-grouped-menu-item>

                                    </li>
                                </ng-container>

                                <li *ngIf="navbar.current && !navbar.current.isGroupedMenu" class="top-nav nav-item dropdown non-grouped active">
                                    <scrm-menu-item [item]="navbar.current" [index]="1"></scrm-menu-item>
                                </li>

                                <li *ngFor="let item of navbar.menu; let i = index;" class="top-nav nav-item dropdown main-grouped">
                                    <scrm-grouped-menu-item
                                        [item]="item"
                                        [subNavCollapse]="subNavCollapse"
                                        [index]="i+2"
                                    >
                                    </scrm-grouped-menu-item>

                                </li>
                            </ul>

                            <scrm-menu-items-list [items]="navbar.all.modules"
                                                  labelKey="LBL_TABGROUP_ALL"
                                                  [index]="navbar.menu.length + 2">
                            </scrm-menu-items-list>

                        </ng-container>


                        <!-- END Navbar with grouped tabs -->

                        <!-- Navbar with non-grouped tabs -->

                        <ng-container *ngIf="vm.userPreferences['navigation_paradigm'] != 'gm'">

                            <ul class="navbar-nav">
                                <li *ngIf="navbar.current && !navbar.current.isGroupedMenu" class="top-nav nav-item dropdown non-grouped active">
                                    <scrm-menu-item [item]="navbar.current" [index]="1"></scrm-menu-item>
                                </li>

                                <ng-container *ngIf="navbar.current?.submenu  && navbar.current.isGroupedMenu">
                                    <li class="top-nav nav-item dropdown main-grouped">
                                        <scrm-grouped-menu-item
                                            [item]="navbar.current"
                                            [subNavCollapse]="subNavCollapse"
                                            [index]="1">
                                        </scrm-grouped-menu-item>
                                    </li>
                                </ng-container>

                                <li *ngFor="let item of navbar.menu; let i = index" class="top-nav nav-item dropdown non-grouped">
                                    <scrm-menu-item [item]="item" [index]="i+2"></scrm-menu-item>
                                </li>
                            </ul>

                        <scrm-menu-items-list [items]="navbar.all.modules"
                                              labelKey="LBL_MORE"
                                                [index]="navbar.menu.length + 2">
                        </scrm-menu-items-list>

                        </ng-container>

                        <!-- END Navbar with non-grouped tabs -->

                </div>

                <ng-container *ngTemplateOutlet="actionIcons"></ng-container>

                <!-- Global Links -->

                <div class="global-links action-dropdown" ngbDropdown>
                    <ul class="navbar-nav">
                        <li class="global-link-item">
                            <a class="nav-link primary-global-link" ngbDropdownToggle>
                                <scrm-image class="global-action-icon sicon-2x" image="user"></scrm-image>
                            </a>
                            <div aria-labelledby="navbarDropdownMenuLink"
                                 class="dropdown-menu global-links-dropdown border shadow-sm-2 dropdown-menu-right" ngbDropdownMenu>
                                <span
                                    class="global-user-name">{{ navbar.currentUser.firstName }} {{ navbar.currentUser.lastName }}</span>
                                <ng-container *ngIf="navbar.globalActions">
                                    <ng-container
                                        *ngFor="let globalAction of navbar.globalActions; let first = first; let last = last;">
                                        <a class="dropdown-item global-links-sublink"
                                           href="{{ globalAction.link.url }}"
                                           ngbDropdownItem
                                           target="{{ globalAction.link.target }}">{{ globalAction.link.label }}
                                        </a>
                                        <hr *ngIf="last === true || first === true"/>
                                    </ng-container>

                                </ng-container>
                                <scrm-logout-ui></scrm-logout-ui>
                            </div>
                        </li>
                    </ul>
                </div>

                <!-- END Global Links -->

            </nav>

            <!-- End of navbar section with data once authenticated -->

        </ng-container>
    </ng-container>

    <ng-template #actionIcons>
        <div class="action-group navbar-action-group">
            <!--Quick Create-->
            <div class="action-new action-dropdown" ngbDropdown>
                <ul class="navbar-nav border-0">
                    <li class="global-link-item">
                        <a class="action-link primary-global-link" type="button" aria-label="Quick Create" ngbDropdownToggle>
                            <scrm-image class="action-btn-icon" image="plus"></scrm-image>
                        </a>
                        <ul [class.dropdown-menu-right]="!mobileNavbar"
                            [class.dropdown-menu-right-center]="mobileNavbar"
                            class="dropdown-menu dropdown-menu-left border shadow-sm-2" ngbDropdownMenu>

                            <ng-container *ngIf="(navbar?.current?.module ?? '') && currentQuickActions.length">
                                <li class="new-list-item-header font-weight-bold">
                                    <scrm-label labelKey="LBL_MODULE_NAME" [module]="navbar.current.module"></scrm-label>
                                </li>
                                <li class="new-list-item" *ngFor="let moduleQuickAction of currentQuickActions" ngbDropdownItem>
                                    <ng-container *ngIf="!moduleQuickAction.process">
                                        <a [routerLink]="moduleQuickAction.url" [queryParams]="moduleQuickAction?.params ?? null" class="d-flex align-items-center">
                                            <scrm-label [labelKey]="moduleQuickAction.labelKey" [module]="navbar.current.module" class="new-list-item-label"></scrm-label>
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="moduleQuickAction.process">
                                        <a (click)="handleProcess(moduleQuickAction)" class="d-flex align-items-center">
                                            <scrm-label [labelKey]="moduleQuickAction.labelKey" [module]="navbar.current.module" class="new-list-item-label"></scrm-label>
                                        </a>
                                    </ng-container>

                                </li>
                            </ng-container>

                            <ng-container *ngIf="(this?.navigation?.quickActions ?? []).length">
                                <li class="new-list-item-header font-weight-bold">
                                    <scrm-label labelKey="LBL_QUICK_ACTIONS"></scrm-label>
                                </li>
                                <li class="new-list-item" *ngFor="let quickAction of (this?.navigation?.quickActions ?? [])" ngbDropdownItem>
                                    <ng-container *ngIf="!quickAction.process">
                                        <a [routerLink]="quickAction.url" [queryParams]="quickAction?.params ?? null" class="d-flex align-items-center">
                                            <scrm-label [labelKey]="quickAction.labelKey" [module]="quickAction.module" class="new-list-item-label"></scrm-label>
                                        </a>
                                    </ng-container>
                                    <ng-container *ngIf="quickAction.process">
                                        <a (click)="handleProcess(quickAction)" class="d-flex align-items-center">
                                            <scrm-label [labelKey]="quickAction.labelKey" [module]="quickAction.module" class="new-list-item-label"></scrm-label>
                                        </a>
                                    </ng-container>
                                </li>
                            </ng-container>
                        </ul>
                    </li>
                </ul>
            </div>
            <!--Recently Viewed-->
            <div class="action-history action-dropdown" ngbDropdown>
                <ul class="navbar-nav border-0">
                    <li class="global-link-item">
                        <a class="action-link primary-global-link" type="button" aria-label="Recently Viewed" ngbDropdownToggle>
                            <scrm-image class="action-btn-icon" image="recently_viewed"></scrm-image>
                        </a>
                        <div class="dropdown-menu border shadow-sm-2 dropdown-menu-right scrollbar-thick recently-viewed-nav-header"
                             [class.dropdown-menu-right]="!mobileNavbar" ngbDropdownMenu>
                                 <scrm-recently-viewed [menuItems]="recentlyViewed$ | async | slice:0:recentlyViewedCount"
                                                       ngbDropdownItem class="recently-viewed"></scrm-recently-viewed>
                        </div>
                    </li>
                </ul>
            </div>

            <!--Searchbar-->
            <div class="d-flex align-items-center px-1 action-search">
                <a class="search-mobile-view action-link primary-global-link" [ngClass]="isSearchBoxVisible() ? 'd-none' : 'd-block'"
                   type="button" (click)="openSearchBox()" aria-label="Search">
                    <scrm-image class="action-btn-icon" image="search"></scrm-image>
                </a>

                <div [ngClass]="isSearchBoxVisible() ? 'd-block' : 'd-none'" [@mobileSearchBarAnm]>
                    <scrm-search-bar
                        [labelKey]="'LBL_SEARCH'"
                        [klass]="'search-bar-global'"
                        [searchTrigger]="'enter'"
                        [isMobile]="isSmallScreen()"
                        (isSearchVisible)="closeSearchBox($event)"
                        (searchExpression)="search($event)" #searchTerm>
                    </scrm-search-bar>
                </div>
            </div>
            <!--Notifications-->
            <div *ngIf="notificationsEnabled() && checkAppStrings(vm.appStrings) && arePreferencesInitialized(vm.userPreferences)"
                 class="action-alert action-dropdown" ngbDropdown #alertDropdown="ngbDropdown">
                <ul class="navbar-nav border-0">
                    <li class="global-link-item">
                        <a class="action-link primary-global-link" type="button"
                           (mouseenter)="markAsRead()" ngbDropdownToggle>
                            <scrm-image class="action-btn-icon" image="alert"></scrm-image>
                        </a>
                        <ng-container *ngIf="(notificationCount$ | async) as notificationCount">
                                    <span *ngIf="(notificationCount ?? false)"
                                          class="badge badge-position rounded-pill bg-danger text-white">
                                        <ng-container *ngIf="notificationCount > 0">{{notificationCount }}</ng-container>
                                    </span>
                        </ng-container>
                        <div class="dropdown-menu border shadow-sm-2 dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink"
                             (click)="closeNotificationMenu()" ngbDropdownMenu>
                            <scrm-notifications></scrm-notifications>
                        </div>
                    </li>
                </ul>
            </div>

        </div>
    </ng-template>

</div>

<!-- End of main navbar section -->
